// src/store.js

import { configureStore } from '@reduxjs/toolkit';

// Vatandaş tarafı slice'ları
import vatandasApplicationReducer from './vatandas/redux/slices/vatandasApplicationSlice';
import vatandasAuthReducer from './vatandas/redux/slices/vatandasAuthSlice';
import vatandasImportantPlacesReducer from './vatandas/redux/slices/vatandasImportantPlacesSlice';

import vatandasSurveyReducer from './vatandas/redux/slices/vatandasSurveySlice';
import vatandasTrackingReducer from './vatandas/redux/slices/vatandasTrackingSlice';


// Belediye tarafı slice'ları
import assignmentReducer from './belediye/redux/slices/assignmentSlice';
import belediyeApplicationDetailsReducer from './belediye/redux/slices/belediyeApplicationDetailsSlice';
import belediyeApplicationsReducer from './belediye/redux/slices/belediyeApplicationsSlice';
import belediyeAuthReducer from './belediye/redux/slices/belediyeAuthSlice';
import belediyeForwardLogsReducer from "./belediye/redux/slices/belediyeForwardLogsSlice";

import belediyeSurveyReportsReducer from "./belediye/redux/slices/belediyeSurveyReportsSlice";
import profileReducer from './belediye/redux/slices/profileSlice.js';
import sahaAssignmentsReducer from './belediye/redux/slices/sahaAssignmentsSlice';
import belediyeReportV1Reducer from "./belediye/redux/slices/belediyeReportV1Slice";

import belediyeFeatureFlagsReducer from "./belediye/redux/slices/belediyeFeatureFlagsSlice";
import belediyeCloseApprovalReducer from "./belediye/redux/slices/belediyeCloseApprovalSlice";
import belediyeNotificationsReducer from "./belediye/redux/slices/belediyeNotificationsSlice";

import belediyeHalkMasasiReducer from "./belediye/redux/slices/belediyeHalkMasasiSlice";

import authzReducer from "./belediye/redux/slices/authzSlice";

// FAZ-28: Kurum İçi Görevler
import internalTasksReducer from "./belediye/redux/slices/internalTasksSlice";

import belediyeDashboardV2Reducer from "./belediye/redux/slices/belediyeDashboardV2Slice";

import belediyeApplicationSmsReducer from "./belediye/redux/slices/belediyeApplicationSmsSlice";
// Tek store oluşturuyoruz
const store = configureStore({
  reducer: {
    // Vatandaş slice'ları
    vatandasApplication: vatandasApplicationReducer,
    vatandasAuth: vatandasAuthReducer,
    vatandasSurvey: vatandasSurveyReducer,
    vatandasTracking: vatandasTrackingReducer,
    
    vatandasImportantPlaces: vatandasImportantPlacesReducer,

    // Belediye slice'ları
    belediyeAuth: belediyeAuthReducer,
    belediyeApplications: belediyeApplicationsReducer,
    belediyeApplicationDetails: belediyeApplicationDetailsReducer,
    belediyeDashboardV2: belediyeDashboardV2Reducer,

    sahaAssignments: sahaAssignmentsReducer, // <-- yeni
    assignment: assignmentReducer,
    profile: profileReducer,
    belediyeForwardLogs: belediyeForwardLogsReducer,
    belediyeSurveyReports: belediyeSurveyReportsReducer,
    belediyeReportV1: belediyeReportV1Reducer, 
    belediyeApplicationSms: belediyeApplicationSmsReducer, 

    belediyeFeatureFlags: belediyeFeatureFlagsReducer,
    belediyeCloseApproval: belediyeCloseApprovalReducer,
    belediyeNotifications: belediyeNotificationsReducer,

    belediyeHalkMasasi: belediyeHalkMasasiReducer,

    // FAZ-12: izin altyapısı — permission_ui şalteri kapalıyken kimse okumaz
    authz: authzReducer,

    // FAZ-28: Kurum İçi Görevler
    internalTasks: internalTasksReducer,
  },
});

export default store;